module.exports = __webpack_public_path__ + "static/media/cigna.b182ead3.PNG";